import { useEffect, useState } from 'react';

const STORAGE_KEY = 'axeo_cookie_consent';
const CHANGE_EVENT = 'cookie-consent-changed';
const REOPEN_EVENT = 'cookie-consent-reopen';

export function getCookieConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** Enregistre le choix de l'utilisateur et notifie les composants à l'écoute (ex. AnalyticsScripts). */
export function setCookieConsent(analytics) {
  const value = { analytics, decideLe: new Date().toISOString() };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: value }));
  return value;
}

/** Rouvre le bandeau de consentement (ex. depuis le lien "Gérer les cookies" du footer). */
export function reopenCookieConsent() {
  window.dispatchEvent(new Event(REOPEN_EVENT));
}

/** Expose le consentement courant (null = pas encore de choix) et se met à jour en direct. */
export function useCookieConsent() {
  const [consent, setConsent] = useState(() => getCookieConsent());

  useEffect(() => {
    function onChange(e) {
      setConsent(e.detail);
    }
    window.addEventListener(CHANGE_EVENT, onChange);
    return () => window.removeEventListener(CHANGE_EVENT, onChange);
  }, []);

  return consent;
}

export function useCookieConsentReopen(onReopen) {
  useEffect(() => {
    window.addEventListener(REOPEN_EVENT, onReopen);
    return () => window.removeEventListener(REOPEN_EVENT, onReopen);
  }, [onReopen]);
}
